const INTERVAL_MS = 6000

// Banner carousel: arrows, dots, autoplay that pauses on hover/focus and is
// off for people who prefer reduced motion.
export default function initCarousel(root) {
  const track = root.querySelector(".hv-carousel__track")
  const slides = Array.from(root.querySelectorAll(".hv-carousel__slide"))
  const dots = Array.from(root.querySelectorAll("[data-carousel-dot]"))
  if (slides.length < 2) return

  let index = 0
  let timer = null
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches

  const go = (next) => {
    index = (next + slides.length) % slides.length
    track.style.transform = `translateX(-${index * 100}%)`
    slides.forEach((slide, i) => {
      slide.setAttribute("aria-hidden", String(i !== index))
      slide.querySelectorAll("a[href]").forEach((link) => (link.tabIndex = i === index ? 0 : -1))
    })
    dots.forEach((dot, i) => dot.setAttribute("aria-current", String(i === index)))
  }

  const stop = () => {
    clearInterval(timer)
    timer = null
  }
  const start = () => {
    if (reducedMotion) return
    stop()
    timer = setInterval(() => go(index + 1), INTERVAL_MS)
  }

  root.querySelector("[data-carousel-prev]").addEventListener("click", () => go(index - 1))
  root.querySelector("[data-carousel-next]").addEventListener("click", () => go(index + 1))
  dots.forEach((dot, i) => dot.addEventListener("click", () => go(i)))

  root.addEventListener("mouseenter", stop)
  root.addEventListener("mouseleave", start)
  root.addEventListener("focusin", stop)
  root.addEventListener("focusout", start)

  go(0)
  start()
}

// Google Translate cannot touch text baked into images, so banners carry their
// EN files in data-en-src / data-en-srcset and swap them in when the language
// switch reports "en". Images without an EN file keep the LT one.
export function initBannerLanguage(root) {
  const swaps = [
    ...Array.from(root.querySelectorAll("img[data-en-src]")).map((el) => ({ el, attr: "src", en: el.dataset.enSrc })),
    ...Array.from(root.querySelectorAll("source[data-en-srcset]")).map((el) => ({ el, attr: "srcset", en: el.dataset.enSrcset })),
  ].map((swap) => ({ ...swap, lt: swap.el.getAttribute(swap.attr) }))
  if (swaps.length === 0) return

  document.addEventListener("hv:language", (event) => {
    const english = event.detail === "en"
    swaps.forEach(({ el, attr, en, lt }) => el.setAttribute(attr, english ? en : lt))
  })
}
